<template>
  <div :style="{ zIndex: $lg.config.zIndex.navbar }">
    <LGSidebar
      :menu="menu"
      :produtos="produtos"
    />

    <header class="lg-aa-layout__topo">
      <PSkeleton
        v-if="$store.state.layout.carregandoLayout"
        :aria-label="$t_v2('49043', 'Clique para abrir o menu lateral')"
        class="lg-aa-layout__topo__sidebar"
        height="25px"
        width="25px"
      />
      <a
        v-else
        id="btnSidebar"
        tabindex="0"
        class="lg-aa-layout__topo__sidebar"
        :aria-label="$t_v2('49043', 'Clique para abrir o menu lateral')"
        @click="sidebarClick"
        @keydown.enter="sidebarClick"
      >
        <i class="fa fa-bars" />
      </a>

      <PSkeleton
        v-if="$store.state.layout.carregandoLayout"
        class="lg-aa-layout__topo__logotipo"
        height="50px"
        width="100px"
      />
      <!-- eslint-disable-next-line -->
      <img
        v-else
        :src="logotipo"
        :alt="nomePortal"
        class="lg-aa-layout__topo__logotipo"
        style="cursor: pointer"
        @click.stop="voltarParaHome"
      />

      <div class="lg-aa-separador--vertical" />

      <PSkeleton
        v-if="$store.state.layout.carregandoLayout"
        class="lg-aa-layout__topo__nomePortal"
        :style="nomePortalStyle"
        height="25px"
        width="60px"
      />
      <p
        v-else
        class="lg-aa-layout__topo__nomePortal"
        :style="nomePortalStyle"
      >
        {{ nomePortal }}
      </p>

      <LGBarraPesquisa
        v-if="$lg.breakpoint.smAndUp && itensPesquisados !== null"
        :itens-pesquisados="itensPesquisados"
        @pesquisar="$emit('pesquisar', $event)"
        @pesquisar-change="$emit('pesquisar-change', $event)"
      />

      <LGSidebarPesquisa
        v-if="itensPesquisados !== null"
        :itens-pesquisados="itensPesquisados"
        @pesquisar="$emit('pesquisar', $event)"
        @pesquisar-change="$emit('pesquisar-change', $event)"
      />

      <div class="lg-aa-layout__topo__acoes">
        <div
          v-if="mostrarBotaoPesquisaMobile"
          class="lg-aa-layout__topo__botao"
        >
          <i
            id="btnSidebarPesquisa"
            class="pi pi-search p-text-secondary p-d-sm-none lg-aa-font-size--14"
            role="img"
            @click="sidebarPesquisaClick()"
          />
        </div>

        <slot name="acoes" />

        <div
          ref="menuUsuarioDiv"
          class="lg-aa-layout__topo__menuUsuario"
        >
          <LGAvatar
            :loading="$store.state.layout.carregandoUsuario"
            class="lg-aa-layout__topo__menuUsuario__foto"
            :alt="usuario.nome"
            :avatar="usuario.foto"
            tabindex="0"
            @click.stop="menuUsuarioClick($event)"
            @keydown.enter.stop="menuUsuarioClick($event)"
          />
          <LGMenuUsuario
            ref="menuUsuario"
            :dados-usuario="usuario"
            :modo-sidebar="menuUsuarioModoSidebar"
            @upload-foto="$attrs.onUploadFoto"
          />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import PSkeleton from 'primevue/skeleton';

import LGAvatar from 'lg-vue-components/avatar';
import LGSidebar from 'lg-vue-components/sidebar';
import LGMenuUsuario from 'lg-vue-components/menuUsuario';
import LGBarraPesquisa from 'lg-vue-components/barraPesquisa';
import LGSidebarPesquisa from 'lg-vue-components/sidebarPesquisa';

export default {
  name: 'LGTopo',
  components: {
    PSkeleton,
    LGAvatar,
    LGSidebar,
    LGMenuUsuario,
    LGBarraPesquisa,
    LGSidebarPesquisa,
  },
  props: {
    nomePortal: {
      type: String,
      required: true,
    },
    logotipo: {
      type: String,
      required: true,
    },
    menu: {
      type: Array,
      required: true,
    },
    produtos: {
      type: Array,
      default: () => [],
    },
    usuario: {
      type: Object,
      required: true,
    },
    itensPesquisados: {
      type: Array,
      default: null,
    },
    mostrarBotaoPesquisaMobile: {
      type: Boolean,
      default: true,
    },
    menuUsuarioModoSidebar: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['pesquisar', 'pesquisar-change'],
  computed: {
    nomePortalStyle() {
      if (this.itensPesquisados === null) {
        return { flex: '1' };
      }
      return '';
    },
    isMobile() {
      return this.$lg.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.inicializeShortcut();
  },
  methods: {
    ...mapMutations({
      sidebarPesquisaClick: 'layout/setSidebarPesquisaAtiva',
    }),
    inicializeShortcut() {
      document.addEventListener(
        'keyup',
        (evt) => {
          try {
            if (evt.ctrlKey && evt.shiftKey && evt.key.toUpperCase() === '!') {
              this.$store.commit('layout/setSidebarAtiva');
              this.$refs.menuUsuario.forcarFechamentoMenuUsuario();

              if (this.$eventBus) {
                this.$eventBus.emit('forcarFechamentoSidebarPesquisa');
                this.$eventBus.emit('fecharOverlayPanel');
              }
            }

            if (evt.ctrlKey && evt.shiftKey && evt.key.toUpperCase() === '@') {
              const menuUsuarioDiv = this.$refs.menuUsuarioDiv.children[0];

              const avatar = document.getElementById('imagem');

              avatar.focus();

              this.$store.commit('layout/setSidebarAtiva', true);

              if (this.$eventBus) {
                this.$eventBus.emit('forcarFechamentoSidebarPesquisa');
                this.$eventBus.emit('fecharOverlayPanel');
              }

              this.$refs.menuUsuario.toggleMenuUsuario(
                this.isMobile ? null : menuUsuarioDiv,
              );
            }
          } catch {
            /* ignore o erro */
          }
        },
        false,
      );
    },
    pesquisar(termoPesquisa) {
      this.$emit('pesquisar', termoPesquisa);
    },
    sidebarClick() {
      this.$store.commit('layout/setSidebarAtiva');
    },
    menuUsuarioClick(event) {
      this.$refs.menuUsuario.toggleMenuUsuario(event);
    },
    voltarParaHome() {
      if (this.$route.redirectedFrom !== '/' && this.$route.path !== '/') {
        this.$router.push('/').catch(() => {
          /* ignore se houver erro de duplicidade */
        });
      }
    },
  },
};
</script>
